import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Badge } from '@aws-amplify/ui-react';
import {
    Table,
    TableRow,
    TableCell,
    TableBody,
    TableHead } from '@aws-amplify/ui-react';
import React , { useEffect , useState } from 'react';

const Account = (props) => {
    
    
    return(
        <Container>
            <br/>
            <Row>
                <Table
                caption=""
                highlightOnHover={false}>
                    <TableBody>
                        <TableRow>
                            <TableCell>Account Id</TableCell>
                            <TableCell>12345678910</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Account Files</TableCell>
                            <TableCell>300</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Account Pages</TableCell>
                            <TableCell>10,000</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Query Searches</TableCell>
                            <TableCell>256</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Keyword Searches</TableCell>
                            <TableCell>77</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Entity Searches</TableCell>
                            <TableCell>158</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Row>
        </Container>
    )
}
export default Account;